import { CITY } from 'core/constants';
import LinksButton from 'core/buttons/links-button';
import PropTypes from 'prop-types';
import styles from 'styles/LandingLocalitiesList.module.scss';
import { TEMPLATES_TYPES } from 'components/landing/constants';
import { usePageInfo } from 'context/PageInfoContext';
import useRichTranslation from 'hooks/useRichTranslation';

const LocalitiesColumn = ({ item, indexCol, indexRow }) => {
    const t = useRichTranslation('localities-list');
    const { pageInfo } = usePageInfo();

    const isParentPage = (indexCol, indexRow, pageInfo) => {
        return (
            indexRow === 0 &&
            indexCol === 0 &&
            pageInfo.page_context.deep_level === 2
        );
    };

    const getLabel = (template, indexCol, indexRow, placeLevel) => {
        const indexCondition = indexRow === 0 && indexCol === 0;
        if (
            template === TEMPLATES_TYPES.INSURANCE_LOCATION &&
            indexCondition &&
            placeLevel === CITY
        ) {
            return `${item.n} ${t('places.province')}`;
        }
        return item.n;
    };

    const label = getLabel(
        pageInfo.template_type,
        indexCol,
        indexRow,
        pageInfo.place_level
    );

    const parentPage = isParentPage(indexCol, indexRow, pageInfo);
    const displayName = `${t('display-name')} ${label}`;

    return (
        <div className={styles.city_item}>
            <LinksButton
                href={item.l}
                target="_blank"
                rel="noreferrer"
                label={parentPage ? label : displayName}
                special={parentPage}
            />
        </div>
    );
};

LocalitiesColumn.propTypes = {
    item: PropTypes.shape({
        n: PropTypes.string,
        l: PropTypes.string
    }),
    indexCol: PropTypes.number,
    indexRow: PropTypes.number
};

export default LocalitiesColumn;
